var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _g, _rect5, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 388H396V406H78V388Z",
    fill: "url(#paint0_linear_106_580)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297 296H396V314H297V296Z",
    fill: "url(#paint1_linear_106_580)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297 213H396V231H297V213Z",
    fill: "url(#paint2_linear_106_580)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M297 254H396V272H297V254Z",
    fill: "url(#paint3_linear_106_580)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 443H396V461H78V443Z",
    fill: "url(#paint4_linear_106_580)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#1A5DBE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9205 111H38.2614V41.1818H62.3977C69.3295 41.1818 75.2841 42.5795 80.2614 45.375C85.2614 48.1477 89.1023 52.1364 91.7841 57.3409C94.4659 62.5455 95.8068 68.7727 95.8068 76.0227C95.8068 83.2955 94.4545 89.5455 91.75 94.7727C89.0682 100 85.1932 104.011 80.125 106.807C75.0795 109.602 69.0114 111 61.9205 111ZM50.9091 100.057H61.3068C66.1705 100.057 70.2273 99.1705 73.4773 97.3977C76.7273 95.6023 79.1705 92.9318 80.8068 89.3864C82.4432 85.8182 83.2614 81.3636 83.2614 76.0227C83.2614 70.6818 82.4432 66.25 80.8068 62.7273C79.1705 59.1818 76.75 56.5341 73.5455 54.7841C70.3636 53.0114 66.4091 52.125 61.6818 52.125H50.9091V100.057ZM170.21 76.0909C170.21 83.6136 168.801 90.0568 165.983 95.4205C163.188 100.761 159.369 104.852 154.528 107.693C149.71 110.534 144.244 111.955 138.131 111.955C132.017 111.955 126.54 110.534 121.699 107.693C116.881 104.83 113.063 100.727 110.244 95.3864C107.449 90.0227 106.051 83.5909 106.051 76.0909C106.051 68.5682 107.449 62.1364 110.244 56.7955C113.063 51.4318 116.881 47.3295 121.699 44.4886C126.54 41.6477 132.017 40.2273 138.131 40.2273C144.244 40.2273 149.71 41.6477 154.528 44.4886C159.369 47.3295 163.188 51.4318 165.983 56.7955C168.801 62.1364 170.21 68.5682 170.21 76.0909ZM157.494 76.0909C157.494 70.7955 156.665 66.3295 155.006 62.6932C153.369 59.0341 151.097 56.2727 148.188 54.4091C145.278 52.5227 141.926 51.5795 138.131 51.5795C134.335 51.5795 130.983 52.5227 128.074 54.4091C125.165 56.2727 122.881 59.0341 121.222 62.6932C119.585 66.3295 118.767 70.7955 118.767 76.0909C118.767 81.3864 119.585 85.8636 121.222 89.5227C122.881 93.1591 125.165 95.9205 128.074 97.8068C130.983 99.6705 134.335 100.602 138.131 100.602C141.926 100.602 145.278 99.6705 148.188 97.8068C151.097 95.9205 153.369 93.1591 155.006 89.5227C156.665 85.8636 157.494 81.3864 157.494 76.0909ZM241.929 64.7386H229.179C228.815 62.6477 228.145 60.7955 227.168 59.1818C226.19 57.5455 224.974 56.1591 223.52 55.0227C222.065 53.8864 220.406 53.0341 218.543 52.4659C216.702 51.875 214.713 51.5795 212.577 51.5795C208.781 51.5795 205.418 52.5341 202.486 54.4432C199.554 56.3295 197.259 59.1023 195.599 62.7614C193.94 66.3977 193.111 70.8409 193.111 76.0909C193.111 81.4318 193.94 85.9318 195.599 89.5909C197.281 93.2273 199.577 95.9773 202.486 97.8409C205.418 99.6818 208.77 100.602 212.543 100.602C214.634 100.602 216.588 100.33 218.406 99.7841C220.247 99.2159 221.895 98.3864 223.349 97.2955C224.827 96.2045 226.065 94.8636 227.065 93.2727C228.088 91.6818 228.793 89.8636 229.179 87.8182L241.929 87.8864C241.452 91.2045 240.418 94.3182 238.827 97.2273C237.259 100.136 235.202 102.705 232.656 104.932C230.111 107.136 227.134 108.864 223.724 110.114C220.315 111.341 216.531 111.955 212.372 111.955C206.236 111.955 200.759 110.534 195.94 107.693C191.122 104.852 187.327 100.75 184.554 95.3864C181.781 90.0227 180.395 83.5909 180.395 76.0909C180.395 68.5682 181.793 62.1364 184.588 56.7955C187.384 51.4318 191.19 47.3295 196.009 44.4886C200.827 41.6477 206.281 40.2273 212.372 40.2273C216.259 40.2273 219.872 40.7727 223.213 41.8636C226.554 42.9545 229.531 44.5568 232.145 46.6705C234.759 48.7614 236.906 51.3295 238.588 54.375C240.293 57.3977 241.406 60.8523 241.929 64.7386Z",
    fill: "#FAFAFD"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 171,
    width: 180,
    height: 180,
    rx: 32,
    fill: "#1A5DBE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.974 301L113.083 221H131.56L144.802 276.586H145.466L160.075 221H175.896L190.466 276.703H191.169L204.411 221H222.888L199.997 301H183.513L168.278 248.695H167.653L152.458 301H135.974Z",
    fill: "#FAFAFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_580",
    x: 26.2617,
    y: 40.2266,
    width: 219.668,
    height: 87.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_580",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_580",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_580",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_580",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_580",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103F91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.efe708819b41763e10d3da3319f83169.svg";
export { ForwardRef as ReactComponent };